import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as searchActions from '~/search2/actions';
import Helpers from '~/utils/Helpers';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
import CSArtifactRow from '~/search2/components/CSArtifactRow';
import CSComponentRow from '~/search2/containers/CSComponentRow';
import PermissionsHelper from '~/utils/PermissionsHelper';
import Helmet from 'react-helmet';
import MetadataService from '~/utils/MetadataService';
import SearchBottom from '~/search2/containers/SearchBottom';
type SearchResultsProps = {
  actions: object;
  searchDataState: object;
  myState: object;
  orgState: object;
};
class SearchResults extends React.Component<SearchResultsProps, {}> {
  componentDidMount() {
    this.runFirstQuery();
  }
  runFirstQuery = () => {
    let hash = window.location.hash.slice(1),
      firstQuery = '';
    if (hash.length === 0 && window.location.search && window.location.search.indexOf('query=')) {
      hash = window.location.search.slice(1);
    }
    if (hash.indexOf('query=') !== -1) {
      let newQuery = hash.split('query=')[1];
      firstQuery = Helpers.decode(newQuery).trim();
    }
    if (firstQuery.length > 0) {
      this.props.actions.updateFilters({ query: firstQuery });
    } else {
      this.props.actions.search('');
    }
  };
  loadMoreSearchResults = () => {
    const { searchDataState } = this.props;
    const { contents: searchResults = [], metadata = {}, filters = {} } = searchDataState;
    const { page: currentPage, totalPages } = metadata;
    const { query = '' } = filters;
    if (searchResults.length > 0 && currentPage + 1 < totalPages) {
      this.props.actions.search(query, currentPage + 1, true);
    }
  };
  getQueryWords() {
    const { searchDataState } = this.props;
    const { filters = {} } = searchDataState;
    const { query = '' } = filters;
    let q = _.clone(query);
    q = this.removeFacet(q, 'language');
    q = this.removeFacet(q, 'type');
    q = this.removeFacet(q, 'severity');
    q = this.removeFacet(q, 'cve');
    q = this.removeFacet(q, 'license');
    q = q.replace(/\s+/g, ' '); // remove more than one consective space in a row
    return q.split(' ');
  }
  isInSearchBox() {
    return document.activeElement && document.activeElement.id === 'search-input';
  }
  removeFacet(query, facetName) {
    let result = query.replace(new RegExp(facetName + ':[^\\s]+', 'gi'), ''); // remove this facet if already in
    return this.isInSearchBox() ? result : result.replace(/\s+/g, ' '); // remove more than one consective space in a row
  }
  render() {
    const { myState, orgState, searchDataState } = this.props;
    const isLoggedInAndPaidOrTrialing = PermissionsHelper.isLoggedInAndPaidOrTrialing(
      myState,
      orgState
    );
    const { cvss = 'cvss2' } = searchDataState;
    const {
      contents: searchResults = [],
      isBackendDown,
      isRequestingResults,
      isFiltering,
    } = searchDataState;
    let queryWords = this.getQueryWords() || [];
    let rows =
      searchResults.map(function(searchResult, index) {
        if (searchResult.type === 'artifact') {
          return (
            <CSArtifactRow
              isCvss3={cvss === 'cvss3'}
              isLoggedInAndPaidOrTrialing={isLoggedInAndPaidOrTrialing}
              searchResult={searchResult}
              key={'result-' + searchResult.id + '-' + index}
              queryWords={queryWords}
            />
          );
        } else if (searchResult.type === 'library') {
          return (
            <CSComponentRow
              searchResult={searchResult}
              key={'result-' + searchResult.id + '-' + index}
              queryWords={queryWords}
            />
          );
        }
      }) || [];
    let content = '';
    const msgDisplay = {
      BACKEND_ERROR: (
        <div className="no-results">
          <h4>Search service is unreachable.</h4>
          <p>Please refresh the page and try again.</p>
        </div>
      ),
      REQUESTING_RESULTS: (
        <div className="no-results">
          <h4>Searching...</h4>
          <p>One moment please.</p>
        </div>
      ),
      NO_RESULTS: (
        <div className="no-results">
          <h4>No Results</h4>
          <p>Please adjust your search query</p>
        </div>
      ),
    };
    //This logic is may applicable only be for infinite scrolling type of pagination
    if (isBackendDown) {
      content = <div>{msgDisplay['BACKEND_ERROR']}</div>; //just display error when backend is down
    } else if (isRequestingResults) {
      content = (
        <div className="mb">
          {rows} {msgDisplay['REQUESTING_RESULTS']}{' '}
        </div>
      ); //when loading results show the rows and the Please Wait message
    } else if (rows.length === 0) {
      content = (
        <div>
          {rows} {msgDisplay['NO_RESULTS']}
        </div>
      ); // when there are no further results, show No Results message at the bottom of the result rows
    } else {
      content = <div>{rows}</div>; //Simply show the rows by default
    }
    const meta = MetadataService.generateSearchPageSEO(window.location.href);
    return (
      <div className="grid grid--full" key="search-catalog">
        <Helmet title={SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.name} meta={meta} />
        <div className="grid__item col-1-1">
          <div className="grid">
            <div className="grid__item col-1-1">
              <div
                className={`grid__item ${
                  (isRequestingResults || isFiltering) && !isBackendDown ? 'opacity--3-10' : ''
                }`}
              >
                {content}
              </div>
            </div>
          </div>
        </div>
        {!isBackendDown && !isRequestingResults && (
          <div className="grid__item col-1-1">
            <SearchBottom onVisible={this.loadMoreSearchResults} />
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    searchDataState: state.searchDataState,
    myState: state.myState,
    orgState: state.orgState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(searchActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResults);
